import { ESLESMEYEN_YIBF_GUNCELLE } from "../constants/requestUrls";
import {  postRequest } from "../request";

const eslesmeyenYibfGuncelle = (data) => {
    return postRequest({url:ESLESMEYEN_YIBF_GUNCELLE,data});
}

export default eslesmeyenYibfGuncelle;